export const cookieKey = 'featureFlag';

export const AB_PATTERNS = {
  patternA: 'A',
  patternB: 'B',
} as const;

export type AB_PATTERNS_TYPE = (typeof AB_PATTERNS)[keyof typeof AB_PATTERNS];

export const AB_BUCKET = {
  [AB_PATTERNS.patternA]: {
    // Set Feature into Buckets
  },
  [AB_PATTERNS.patternB]: {
    // Set Feature into Buckets
  },
} as const;

export type ABVariant = (typeof AB_BUCKET)[AB_PATTERNS_TYPE];

export function isABPattern(value: any): value is AB_PATTERNS_TYPE {
  return Object.values(AB_PATTERNS).includes(value);
}
